import { Link } from "react-router-dom";
import { getButtonClassName } from "../components/Button";
import { EmptyState } from "../components/EmptyState";

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-2xl">
      <EmptyState
        action={
          <div className="flex flex-wrap justify-center gap-3">
            <Link className={getButtonClassName("primary")} to="/jobs">
              Browse jobs
            </Link>
            <Link className={getButtonClassName("tonal")} to="/post">
              Post job
            </Link>
            <Link className={getButtonClassName("link")} to="/">
              Back home
            </Link>
          </div>
        }
        title="We couldn't find that page."
        variant="notfound"
      >
        Browse open jobs or post a new one.
      </EmptyState>
    </div>
  );
}
